import { useFeatureIsOn } from '@growthbook/growthbook-react';

/** Whether the Compose area is enabled for this user (GrowthBook `app__compose_enabled`). */
export function useIsComposeEnabled() {
  return useFeatureIsOn('app__compose_enabled');
}
